import { PublishProtocolDialog } from 'client/app/apps/protocols/dialogs/PublishProtocolDialog/PublishProtocolDialog';
export default PublishProtocolDialog;
